import type { FaireProductEntity } from "../../entity_types/product";

export const p_xvrxrhjwyz: FaireProductEntity = {
  token: "p_xvrxrhjwyz",
  type: "product",
  name: "Gold Heart Jewelry Dish - Home Decor & Gifts",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/a39de70d78f1c6e9491f2d8f89e6e149603ab9eb6a6360a265c127dbf17855b0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6709b6853ada332b7772fd6404ca73d789fbf22eca792cba848ec68d4b995ba8.png",
    "https://cdn.faire.com/fastly/ea1e14b87b4cff15f72ea2ef47b3737a7a12e3698eb583fb55867c092a11d565.png",
    "https://cdn.faire.com/fastly/0a5a1c8079f4571f3695a46e95be54650e5955b142e98b56b42b83136dce2994.png",
    "https://cdn.faire.com/fastly/bbdf4dd5cd3d7852c803b3b7710f96204b1139ce9ae9e35578fcdb0407218887.jpeg",
    "https://cdn.faire.com/fastly/ea4ef1a3a412c5f626814cc97ef1a8b5f81172d03d710703cef6d9116a1ceee0.png",
  ],
  priceDollars: 12.33,
  description:
    "Our small trinket tray makes a great gift for Valentine's Day, Mother's Day, Engagements, Bridal Showers, Weddings, and more. This catch all tray features a simple, chic gold heart design that makes it the perfect ring dish for any room.\n\n﻿DETAILS:\n\n• Gold Foil Design\n• Heart Design in Center\n• 3” x 3” Circle Dish\n• Ceramic Jewelry Dish\n• Color: Cream and Gold\n• Box Size: 3.63” x 3.63” x 1”\n• Designed in the USA, Imported\n• Style No. JD042\n\nCARE:  \n\n• Not Intended for Food Use\n• Not Microwave and Not Dishwasher Safe\n• Use a Soft Cloth and Water to Clean\n\nCATEGORIES:\n\n• Engagement, Bridal Shower, Wedding, Bachelorette Party\n\nSTYLE:\n\n• Glam, Boho, Bohemian, Vintage, Shabby Chic, Feminine, Luxe, Girly, Simple, Modern",
  tags: [],
  msrpDollars: 24.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:54.233Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
